<template>
  <div class="relative h-32 w-full border-t-2 border-yellow-500 bg-yellow-20">
    <div
      class="markers hidden"
      :class="mapId"
    ></div>
    <div
      v-if="hqAddress?.[0]?.lat && hqAddress?.[0]?.lon"
      class="flex h-full w-full flex-col gap-3 p-3 px-6"
    >
      <div class="flex items-center gap-4">
        <a
          :href="`/broker/carriers/${insights?.carrier_id}`"
          target="_blank"
          class="text-xl text-yellow-600 underline"
          v-if="markerCarrierData?.[openedMarkerIndex]?.id"
        >
          {{ markerCarrierData?.[openedMarkerIndex]?.name }}
        </a>
        <div class="flex items-center">
          <custom-badge
            :bgColorClass="ratingBgColorClass(rating)"
            colorClass="text-white"
            size="lg"
            :text="rating"
          ></custom-badge>
        </div>
      </div>
      <div class="flex gap-6">
        <div class="gap flex flex-col">
          <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
            Residential Address
          </h4>
          <div
            v-if="markerCarrierData?.[openedMarkerIndex]?.isShowCarrier"
            class="text-xs text-body-color"
          >
            <div class="block">
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses
                  ?.street1
              }}
            </div>
            <div
              v-if="
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses
                  ?.street2
              "
              class="block"
            >
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses
                  ?.street2
              }}
            </div>
            <div class="block">
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses
                  ?.city
              }},
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses
                  ?.state
              }}
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses
                  ?.postal_code
              }}
            </div>
          </div>
          <div
            v-else
            class="text-xs text-body-color"
          >
            <div class="block">{{ activeAssociatedAddress?.street1 }}</div>
            <div
              v-if="activeAssociatedAddress?.street2"
              class="block"
            >
              {{ activeAssociatedAddress?.street2 }}
            </div>
            <div class="block">
              {{ activeAssociatedAddress?.city }},
              {{ activeAssociatedAddress?.state }}
              {{ activeAssociatedAddress?.postal_code }}
            </div>
          </div>
          <!-- <div v-else class="text-xs text-body-color">
              <div class="block">{{ markerCarrierData?.[openedMarkerIndex]?.physical_addresses?.[0]?.street1 }}</div>
              <div v-if="markerCarrierData?.[openedMarkerIndex]?.physical_addresses?.[0]?.street2" class="block">{{ markerCarrierData?.[openedMarkerIndex]?.physical_addresses?.[0]?.street2  }}</div>
              <div class="block">{{ markerCarrierData?.[openedMarkerIndex]?.physical_addresses?.[0]?.city }}, {{ markerCarrierData?.[openedMarkerIndex]?.physical_addresses?.[0]?.state }} {{ markerCarrierData?.[openedMarkerIndex]?.physical_addresses?.[0]?.postal_code }}</div>
            </div> -->
        </div>
        <!-- <div class="flex flex-col gap">
            <h4 class="text-2xs text-gray-over-dark font-bold uppercase mb-2">
              Identifiers
            </h4>
            <div v-if="markerCarrierData[openedMarkerIndex].isShowCarrier" class="text-xs text-body-color">
              <div class="block">{{ capitalizeWords(markerCarrierData[openedMarkerIndex].physical_addresses.street1) }}</div>
              <div v-if="markerCarrierData[openedMarkerIndex].physical_addresses.street2" class="block">{{ capitalizeWords(markerCarrierData[openedMarkerIndex].physical_addresses.street2)  }}</div>
              <div class="block">{{ capitalizeWords(markerCarrierData[openedMarkerIndex].physical_addresses.city) }}, {{ markerCarrierData[openedMarkerIndex].physical_addresses.state }} {{ markerCarrierData[openedMarkerIndex].physical_addresses.postal_code }}</div>
            </div>
            <div v-else class="text-xs text-body-color">
              <div class="block">{{ capitalizeWords(markerCarrierData[openedMarkerIndex].physical_addresses[0].street1) }}</div>
              <div v-if="markerCarrierData[openedMarkerIndex].physical_addresses.street2" class="block">{{ capitalizeWords(markerCarrierData[openedMarkerIndex].physical_addresses[0].street2)  }}</div>
              <div class="block">{{ capitalizeWords(markerCarrierData[openedMarkerIndex].physical_addresses[0].city) }}, {{ markerCarrierData[openedMarkerIndex].physical_addresses[0].state }} {{ markerCarrierData[openedMarkerIndex].physical_addresses[0].postal_code }}</div>
            </div>
          </div> -->
        <div class="gap flex flex-col">
          <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
            HQ Location
          </h4>
          <div
            v-if="markerCarrierData?.[openedMarkerIndex]?.isShowCarrier"
            class="text-xs text-body-color"
          >
            <div class="block">
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses
                  ?.city
              }},
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses
                  ?.state
              }}
            </div>
          </div>
          <div
            v-else
            class="text-xs text-body-color"
          >
            <div class="block">
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses?.[0]
                  ?.city
              }},
              {{
                markerCarrierData?.[openedMarkerIndex]?.physical_addresses?.[0]
                  ?.state
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.gm-style .gm-style-iw-tc::after,
.gm-style-iw-t > .gm-style-iw-tc::after {
  background: #313545 !important;
}
</style>

<script>
import CustomBadge from '@/components/CustomBadge.vue';

export default {
  name: 'GoogleMapInsights',
  components: {
    CustomBadge,
  },
  props: {
    insight: {
      type: Object,
      required: true,
    },
    hqAddress: {
      type: [Object, Array],
      required: true,
    },
    mapId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: true,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
        ],
      },
      mapCenter: {
        lat: parseFloat(this.hqAddress?.[0]?.lat),
        lng: parseFloat(this.hqAddress?.[0]?.lon),
      },
      mapMarkers: [], // this.setMapMarkers(),
      openedMarkerIndex: 0,
      markerCarrierData: [], // this.setMapMarkerData(),
      gmapScriptLoaded: false,
      brokerAuthorityNearbyMapIsLoading: false,
      allMarkers: [],
      allInfoWindows: [],
      currentMarker: null,
      hq_index_list: [],
    };
  },
  computed: {
    rating() {
      return this.$store.state.carriers.showCarrier?.authority_assessment
        ?.rating;
    },
    brokerAuthorityNearbyMapHasLoaded() {
      return this.$store.state.insights?.brokerAuthorityNearbyMapHasLoaded;
    },
    activeAssociatedAddress() {
      let addresses =
        this.markerCarrierData?.[this.openedMarkerIndex]?.physical_addresses;
      if (addresses?.length > 0) {
        return addresses.find((address) => {
          return this.insight?.referenced_ids?.includes(address?.id);
        });
      } else {
        return {};
      }
    },
  },
  mounted() {
    this.loadGoogleMapScript();
  },
  methods: {
    openMarker: function (m) {
      this.openedMarkerID = m.id;
      this.mapMarkers.forEach(function (el) {
        if (el.id == m.id) {
          el.opened = true;
        } else {
          el.opened = false;
        }
      });
    },
    centerMarker: function (m, mIndex = null) {
      var self = this;
      if (!m) {
        self.mapMarkers.forEach(function (el, index) {
          if (index == mIndex) {
            self.mapCenter = {
              lat: el.position.lat,
              lng: el.position.lng,
            };
            el.opened = true;
          } else {
            el.opened = false;
          }
        });
      } else {
        self.openedMarkerID = m.id;
        self.mapMarkers.forEach(function (el) {
          if (el.id == m.id) {
            self.mapCenter = {
              lat: el.position.lat,
              lng: el.position.lng,
            };
            el.opened = true;
          } else {
            el.opened = false;
          }
        });
      }
    },
    setMapMarkers: function (insight) {
      var markers = [];
      const showCarrier = this.$store.state.carriers.showCarrier;
      // console.log('This HQ ADDRESS', this.hqAddress);
      const hqMarkers = this.hqAddress?.map((address) => ({
        id: showCarrier?.id,
        name: showCarrier?.name,
        physical_addresses: address,
        isShowCarrier: true,
      }));
      hqMarkers.forEach(function (el) {
        markers.push({
          id: el?.id,
          label: el?.name,
          position: {
            lat: parseFloat(el?.physical_addresses?.lat),
            lng: parseFloat(el?.physical_addresses?.lon),
          },
          opened: false,
        });
      });
      if (markers?.length > 0) {
        markers[0].opened = true;
      }
      // markers.push({
      //   id : self.hqAddress?.id,
      //   label : self.$store.state.carriers.showCarrier?.name,
      //   position : {
      //     lat : parseFloat(self.hqAddress?.lat),
      //     lng : parseFloat(self.hqAddress?.lon)
      //   },
      //   opened: true,
      // });
      if (insight?.associated_carriers?.length > 0) {
        insight.associated_carriers.forEach(function (el) {
          if (el.physical_addresses.length > 0) {
            el.physical_addresses.forEach(function (el2) {
              if (insight?.referenced_ids?.includes(el2?.id)) {
                markers.push({
                  id: el2?.id,
                  carrierData: el,
                  label: el?.legal_name,
                  position: {
                    lat: parseFloat(el2?.lat),
                    lng: parseFloat(el2?.lon),
                  },
                  opened: false,
                });
              }
            });
          }
        });
      }
      return markers;
    },
    // setMapMarkerData: function(insight) {
    //   var self = this;
    //   var markerData = [];

    //   markerData.push({
    //     id: self.$store.state.carriers.showCarrier?.id,
    //     name: self.$store.state.carriers.showCarrier?.legal_name,
    //     physical_addresses: self.hqAddress,
    //     isShowCarrier: true
    //   });
    //   if (insight?.associated_carriers?.length > 0) {
    //     insight.associated_carriers?.forEach(function(el) {
    //       markerData.push({
    //         id: el.id,
    //         name: el.legal_name,
    //         physical_addresses: el.physical_addresses,
    //         isShowCarrier: false
    //       });
    //     });
    //   }
    //   console.log('Marker', markerData)
    //   return markerData;
    // },
    setMapMarkerData(insight) {
      const showCarrier = this.$store.state.carriers.showCarrier;
      const hqAddress = this.hqAddress;
      const associatedCarriers = insight?.associated_carriers ?? [];
      const hqMarkers = hqAddress?.map((address) => ({
        id: showCarrier?.id,
        name: showCarrier?.legal_name,
        physical_addresses: address,
        isShowCarrier: true,
      }));
      let self = this;
      for (let x = 0; x < hqMarkers?.length; x++) {
        self.hq_index_list.push(x);
      }

      const markerData = [
        // {
        //   id: showCarrier?.id,
        //   name: showCarrier?.legal_name,
        //   physical_addresses: hqAddress,
        //   isShowCarrier: true,
        // },
        ...hqMarkers,
        ...associatedCarriers.flatMap((carrier) => {
          return carrier.physical_addresses
            .filter((addr) => self.insight?.referenced_ids?.includes(addr?.id))
            .map((address) => ({
              id: carrier?.id,
              name: carrier?.legal_name,
              physical_addresses: address,
              isShowCarrier: true,
            }));
        }),
      ];
      return markerData;
    },
    capitalizeWords: function (str) {
      // handle if str is null
      if (str == null || str.size == 0) {
        return null;
      }
      return str
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
        .replace('Llc', 'LLC');
    },
    initializeMap: function () {
      this.brokerAuthorityNearbyMapIsLoading = true;
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      var loc;
      var loc2;
      const map = new window.google.maps.Map(
        document.getElementById(self.mapId),
        {
          center: this.mapCenter,
          zoom: 12,
          mapTypeControl: false,
        }
      );
      map.setOptions({
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
        ],
      });

      const iconShowGray =
        "data:image/svg+xml,%3Csvg width='18' height='25' viewBox='0 0 18 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.804225 14.1393C2.61519 18.4453 5.92803 22.0825 7.73186 23.8596C8.43462 24.5519 9.52789 24.5478 10.2266 23.8514C12.0125 22.0714 15.2936 18.4387 17.1619 14.1393C19.8207 8.02079 15.9 0.390625 8.98305 0.390625C2.0661 0.390625 -1.76901 8.02079 0.804225 14.1393Z' fill='%23AF7443'/%3E%3Ccircle cx='8.94023' cy='9.13188' r='3.17875' fill='white'/%3E%3C/svg%3E%0A";
      const iconShowYellow =
        "data:image/svg+xml,%3Csvg width='18' height='25' viewBox='0 0 18 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.804225 14.1393C2.61519 18.4453 5.92803 22.0825 7.73186 23.8596C8.43462 24.5519 9.52789 24.5478 10.2266 23.8514C12.0125 22.0714 15.2936 18.4387 17.1619 14.1393C19.8207 8.02079 15.9 0.390625 8.98305 0.390625C2.0661 0.390625 -1.76901 8.02079 0.804225 14.1393Z' fill='%23f8c617'/%3E%3Ccircle cx='8.94023' cy='9.13188' r='3.17875' fill='white'/%3E%3C/svg%3E%0A";
      var iconShowCarrier = {
        url: this.isWatchdogActiveOnDomain ? iconShowGray : iconShowYellow,
        scaledSize: new window.google.maps.Size(32.4, 45),
      };
      var icon = {
        // url: "data:image/svg+xml,%3Csvg width='18' height='25' viewBox='0 0 18 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.804225 14.1393C2.61519 18.4453 5.92803 22.0825 7.73186 23.8596C8.43462 24.5519 9.52789 24.5478 10.2266 23.8514C12.0125 22.0714 15.2936 18.4387 17.1619 14.1393C19.8207 8.02079 15.9 0.390625 8.98305 0.390625C2.0661 0.390625 -1.76901 8.02079 0.804225 14.1393Z' fill='%23313545'/%3E%3Ccircle cx='8.94023' cy='9.13188' r='3.17875' fill='white'/%3E%3C/svg%3E%0A",
        url: "data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='10' cy='10' r='6.5' fill='white' stroke='%23313545' stroke-width='6.5'%3E%3C/circle%3E%3C/svg%3E",
        scaledSize: new window.google.maps.Size(32.4, 45),
      };

      this.mapMarkers.forEach(function (el, index) {
        loc = new window.google.maps.LatLng(
          el.position.lat + 0.0005,
          el.position.lng + 0.0005
        );
        loc2 = new window.google.maps.LatLng(
          el.position.lat - 0.0005,
          el.position.lng - 0.0005
        );
        bounds.extend(loc);
        bounds.extend(loc2);
        var coloredIcon = {};
        if (index == 0) {
          coloredIcon = iconShowCarrier;
        } else {
          coloredIcon = icon;
        }
        var infowindow = new window.google.maps.InfoWindow({
          content: el.label,
        });
        var marker = new window.google.maps.Marker({
          position: el.position,
          icon: coloredIcon,
          map: map,
        });
        self.allMarkers.push(marker);
        self.allInfoWindows.push(infowindow);
        // if (index == 0) {
        //     infowindow.open({
        //         anchor: marker,
        //         map,
        //         shouldFocus: false,
        //     })
        //     window.google.maps.event.addListener(infowindow, 'domready', function() {
        //       self.colorInfoWindow();
        //     });
        // }
      });

      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new window.google.maps.LatLng(
          bounds.getNorthEast().lat() + 0.005,
          bounds.getNorthEast().lng() + 0.005
        );
        var extendPoint2 = new window.google.maps.LatLng(
          bounds.getNorthEast().lat() - 0.005,
          bounds.getNorthEast().lng() - 0.005
        );
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
      }

      map.fitBounds(bounds);
      map.panToBounds(bounds);
      self.allMarkers.forEach(function (mkr, idx) {
        mkr.addListener('mouseover', function () {
          // self.allInfoWindows.forEach(function(iw) {
          //     iw.close();
          // });
          if (self.currentMarker) {
            self.currentMarker.close();
          } else {
            self.allInfoWindows[0].close();
          }
          self.allInfoWindows[idx].open({
            anchor: mkr,
            map,
            shouldFocus: false,
          });
          // self.colorInfoWindow();
          if (self.hq_index_list?.includes(idx)) {
            self.forceColorInfoWindow();
          }
          self.openedMarkerIndex = idx;
          self.currentMarker = self.allInfoWindows[idx];
        });
        mkr.addListener('click', async function () {
          // self.colorInfoWindow();
          if (self.hq_index_list?.includes(idx)) {
            self.forceColorInfoWindow();
          }
          await map.panTo(mkr.getPosition());
          self.openedMarkerIndex = idx;
        });
        var markerLink = document.createElement('div');
        markerLink.classList.add('marker-link');
        markerLink.setAttribute('data-markerid', idx);
        var markerList = document.querySelector('.markers.' + self.mapId);
        markerList.appendChild(markerLink);
        markerLink.addEventListener('click', function () {
          window.google.maps.event.trigger(mkr, 'mouseover');
          self.colorInfoWindow();
          window.google.maps.event.trigger(mkr, 'click');
          self.centerMarker(mkr);
          self.openedMarkerIndex = idx;
        });
      });
      self.allInfoWindows[0].open({
        anchor: self.allMarkers[0],
        map,
        shouldFocus: false,
      });
      this.brokerAuthorityNearbyMapIsLoading = true;
      // this.forceColorInfoWindow();
      window.google.maps.event.addListener(
        self.allInfoWindows[0],
        'domready',
        function () {
          self.forceColorInfoWindow();
        }
      );
      map.addListener('mouseover', function () {
        let mapDiv = document?.querySelector(
          '#' + self.mapId + ' > div > div > div[tabindex="0"]'
        );
        mapDiv?.focus({
          preventScroll: true,
        });
      });
    },
    colorInfoWindow: async function () {
      console.log('trying colorinfowindow');
      var markerLabel = document.querySelector(
        '#' + this.mapId + ' .gm-style-iw.gm-style-iw-c .gm-style-iw-d div'
      );
      if (markerLabel) {
        if (
          markerLabel?.innerHTML == this.$store.state.carriers.showCarrier?.name
        ) {
          var firstInfoWindow = document.querySelector(
            '#' + this.mapId + ' .gm-style-iw.gm-style-iw-c'
          );
          if (firstInfoWindow) {
            firstInfoWindow.setAttribute(
              'style',
              `background: ${
                this.isWatchdogActiveOnDomain ? '#6187B0' : '#f8c617'
              } !important; border-color: #f8c617 !important`
            );
            firstInfoWindow.classList.add('primary-window');
          }
        }
      }
    },
    forceColorInfoWindow: function () {
      var firstInfoWindow = document.querySelector(
        '#' + this.mapId + ' .gm-style-iw.gm-style-iw-c'
      );
      if (firstInfoWindow) {
        firstInfoWindow.setAttribute(
          'style',
          `background:${
            this.isWatchdogActiveOnDomain ? '#6187B0' : '#f8c617'
          } !important; border-color: #f8c617 !important`
        );
        firstInfoWindow.classList.add('primary-window');
      }
    },
    loadGoogleMapScript: async function () {
      var self = this;
      // let alreadyLoaded = document.getElementById('g-map-script');
      let alreadyLoaded = document.getElementById('google-autocomplete-script');

      if (!alreadyLoaded) {
        let gMapScript = document.createElement('script');
        gMapScript.setAttribute(
          'src',
          'https://maps.googleapis.com/maps/api/js?key=' +
            process.env.GOOGLE_MAPS_API_KEY +
            '&v=weekly&callback=Function.prototype'
        );
        gMapScript.setAttribute('async', '');
        gMapScript.setAttribute('defer', '');
        gMapScript.setAttribute('id', 'g-map-script');
        await document.body.appendChild(gMapScript);
        gMapScript.addEventListener('load', function () {
          self.gmapScriptLoaded = true;
        });
      } else {
        if (typeof window.google == 'undefined') {
          alreadyLoaded.addEventListener('load', function () {
            self.gmapScriptLoaded = true;
          });
        } else {
          this.gmapScriptLoaded = true;
        }
      }
    },
    ratingBgColorClass: function (rating) {
      switch (rating) {
        case 'Not Authorized':
          return 'bg-red-500';
        case 'Review Required':
          return 'bg-orange-500';
        case 'Acceptable':
          return 'bg-green-500';
        case 'Authorized':
          return 'bg-green-500';
        case 'Authorized Carrier':
          return 'bg-green-500';
        case 'Authorized Broker':
          return 'bg-green-500';
        case 'Authorized Broker/Carrier':
          return 'bg-green-500';
        case 'Unrated':
          return 'bg-body-color';
        default:
          return 'bg-body-color';
      }
    },
  },
  watch: {
    isWatchdogActiveOnDomain: function () {
      this.forceColorInfoWindow();
      this.colorInfoWindow();
      this.initializeMap();
    },
    gmapScriptLoaded: {
      handler: function (newVal, oldVal) {
        let self = this;
        if (
          oldVal == false &&
          newVal == true &&
          self.insight?.id > 0 &&
          (self.insight?.is_type == 'broker_authority_nearby' ||
            self.insight?.is_type === 'broker_authority_same_address')
        ) {
          this.mapMarkers = this.setMapMarkers(this.insight);
          this.markerCarrierData = this.setMapMarkerData(this.insight);
          self.initializeMap();
        }
      },
    },
    insight: function (newVal, oldVal) {
      if (
        newVal?.id > 0 &&
        newVal?.id !== oldVal?.id &&
        (newVal?.is_type == 'broker_authority_nearby' ||
          newVal?.is_type == 'broker_authority_same_address') &&
        this.gmapScriptLoaded == true
      ) {
        this.mapMarkers = this.setMapMarkers(this.insight);
        this.markerCarrierData = this.setMapMarkerData(this.insight);
        this.initializeMap();
      }
    },
  },
};
</script>
